import * as React from 'react';

export default {
  svg: (
    <g>
      <path
        d="M6.935 8.561v1.948H1.948v11.543h18.106V10.509h-4.806V8.561h6.755V24H0V8.561h6.935zM11 0l5.323 5.322L14.946 6.7l-2.97-2.97v15.898h-1.949V3.73L7.057 6.7 5.679 5.322 11.001 0z"
        transform="translate(-852 -240) translate(851 240) translate(1)"
        fill="#222"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </g>
  ),
  viewBox: '0 0 22 30'
};
